

export const getZodiacSign = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;

  if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return "Wodnik";
  if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return "Ryby";
  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return "Baran";
  if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return "Byk";
  if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return "Bliźnięta";
  if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return "Rak";
  if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return "Lew";
  if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return "Panna";
  if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return "Waga";
  if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return "Skorpion";
  if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return "Strzelec";
  return "Koziorożec";
};

export const formatDateForInput = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

export const todayInPoland = (): string => {
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Warsaw",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(new Date());

  const y = parts.find(p => p.type === "year")?.value || new Date().getFullYear().toString();
  const m = parts.find(p => p.type === "month")?.value || (new Date().getMonth() + 1).toString().padStart(2, '0');
  const d = parts.find(p => p.type === "day")?.value || new Date().getDate().toString().padStart(2, '0');

  return `${y}-${m}-${d}`;
};

async function sha256(text: string): Promise<Uint8Array> {
  const data = new TextEncoder().encode(text);
  const buffer = await crypto.subtle.digest("SHA-256", data);
  return new Uint8Array(buffer);
}

export async function getCardOfTheDay(cards: any[]): Promise<{ date: string; index: number; card: any; }> {
  if (!Array.isArray(cards) || cards.length !== 78) {
    throw new Error("cards must contain exactly 78 cards");
  }

  const dateStr = todayInPoland();
  const hash = await sha256(dateStr);

  const n = (hash[0] << 24) | (hash[1] << 16) | (hash[2] << 8) | hash[3];
  const index = (n >>> 0) % 78;

  return {
    date: dateStr,
    index,
    card: cards[index]
  };
}
